module.exports = __webpack_public_path__ + "img/club.feedc5a4.png";